import type { OriginalRootState } from 'redux/rootReducer'

export const selectPayments = (state: OriginalRootState) =>
  state.viewPayment.dataList || []

export const selectIsPaymentsDataLoading = (state: OriginalRootState) =>
  state.viewPayment.isDataLoading

export const selectPaymentCount = (state: OriginalRootState) =>
  state.viewPayment.paymentCount

export const selectViewPaymentPagination = (state: OriginalRootState) =>
  state.viewPayment.gridOption
